// main.js
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueAxios from 'vue-axios'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import wb from './registerServiceWorker'
import tools from '@/utils/tools'   // ← поправьте путь, если у вас другой

console.log('🚀🚀🚀 main.js ВЫПОЛНЯЕТСЯ', new Date().toISOString())

Vue.prototype.$workbox = wb
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// добиваем путь к api через axios
axios.defaults.baseURL = '/api'

// ========== ФОРМАТТЕРЫ ДАТ/ВРЕМЕНИ ==========

Vue.prototype.$dateFormat = (value) => {
  if (value && value.length >= 10) {
    const date = String(value).slice(0, 10)
    return date.slice(8, 10) + '.' + date.slice(5, 7) + '.' + date.slice(0, 4)
  } else return ''
}
Vue.filter('dateFormat', Vue.prototype.$dateFormat)

Vue.prototype.$dateTimeFormat = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return (
      date.slice(8, 10) + '.' + date.slice(5, 7) + '.' + date.slice(0, 4) +
      ' ' + date.slice(11, 13) + ':' + date.slice(14, 16)
    )
  } else return ''
}
Vue.filter('dateTimeFormat', Vue.prototype.$dateTimeFormat)

Vue.prototype.$timeFormat = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return date.slice(11, 13) + 'ч ' + date.slice(14, 16) + 'мин'
  } else return ''
}
Vue.filter('timeFormat', Vue.prototype.$timeFormat)

Vue.prototype.$timeFormatHHmm = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return date.slice(11, 13) + ':' + date.slice(14, 16)
  } else return ''
}
Vue.filter('timeFormatHHmm', Vue.prototype.$timeFormatHHmm)

console.log('🚀🚀🚀 форматтеры зарегистрированы:',
  typeof Vue.prototype.$dateFormat,
  typeof Vue.prototype.$dateTimeFormat)

Vue.filter('onlyCarNumber', function (value) {
  if (value) {
    const words = value.split('/')
    return words[0].trim()
  }
})

Vue.filter('shortName', tools.shortFIO)

// ========== ВОССТАНАВЛИВАЕМ ТОКЕН ==========
// Пытаемся восстановить токен при загрузке приложения
const token = sessionStorage.getItem('token');
if (token) {
  store.commit('auth/token_set', token);
  console.log('✅ Токен восстановлен при инициализации');

  // Опционально: получить данные пользователя
  // store.dispatch('auth/setUser');
}

// ========== ИНТЕРЦЕПТОР ЗАПРОСОВ ==========
axios.interceptors.request.use(
  function (config) {
    // AUTH token для запросов, если он установлен
    // Сначала пробуем из store, потом из sessionStorage
    const token = store.state.auth.token || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log('🔑 Запрос с токеном:', config.url);
    } else {
      console.warn('⚠️ Запрос без токена:', config.url);
      delete config.headers.Authorization
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Vue.use(VueAxios, axios)
Vue.use(Vuelidate)

// ========== ИНТЕРЦЕПТОР ОТВЕТОВ ==========
axios.interceptors.response.use(
  response => response,
  async function (error) {
    // Если нет ответа от сервера
    if (!error.response) {
      console.error('❌ Нет ответа от сервера');
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // 401 - не авторизован
    if (error.response.status === 401) {
      console.warn('🔒 Ошибка 401 - не авторизован');

      // Если токена нет в store - редирект на логин
      if (!store.state.auth.token) {
        console.warn('Токен отсутствует, перенаправление на логин');
        router.push('/login');
        return Promise.reject(error);
      }

      // Предотвращаем бесконечный цикл обновления токена
      if (originalRequest._retry) {
        console.warn('Повторная попытка обновления токена, перенаправление на логин');
        router.push('/login');
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        console.log('🔄 Попытка обновления токена...');
        // Обновляем токен
        const response = await axios.post('/auth/refreshToken');
        const newToken = response.data.token;

        if (newToken) {
          // Обновляем токен в store и sessionStorage
          store.dispatch('auth/setToken', newToken);
          console.log('✅ Токен успешно обновлен');

          // Обновляем заголовок и повторяем запрос
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        } else {
          throw new Error('Новый токен не получен');
        }

      } catch (refreshError) {
        console.error('❌ Ошибка обновления токена:', refreshError);
        // Очищаем токен и перенаправляем на логин
        store.dispatch('auth/logout');
        router.push('/login');
        return Promise.reject(refreshError);
      }
    }

    // Обработка других ошибок
    if (error.response.status === 500 && error.response.data?.errorCode) {
      console.error('Ошибка сервера:', error.response.data);
      // Используем уведомления если они есть
      if (Vue.prototype.$notify) {
        Vue.prototype.$notify('error', error.response.data.message || 'Ошибка сервера');
      }
    }

    return Promise.reject(error);
  }
)

// ========== СОЗДАЁМ ПРИЛОЖЕНИЕ ==========
// Создаем приложение
const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})

// Восстанавливаем сессию до монтирования,
// чтобы роутер-гард увидел уже загруженного user
;(async () => {
  try {
    await store.dispatch('auth/restoreSession')
  } catch (e) {
    console.error('Ошибка восстановления сессии:', e)
  } finally {
    app.$mount('#app')
  }
})()

// меняем тему
vuetify.framework.theme.dark = store.getters['settings/dark']